import { render, staticRenderFns } from "./index.vue?vue&type=template&id=44a70451&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=44a70451&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a70451",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44a70451')) {
      api.createRecord('44a70451', component.options)
    } else {
      api.reload('44a70451', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=44a70451&scoped=true", function () {
      api.rerender('44a70451', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/resource/problemConfiguration/index.vue"
export default component.exports